import { tempMeeApi } from '~/services/api';
import { scopedHeaders } from '~/services/scopedHeaders';
import type { IOfficeMissingInfoProductivityPatch } from '../types/OfficeMissingInfo.api';

// `PATCH /users` drops nested `office_info.productivity` keys, so operatories go through here.
export const updateOfficeProductivity = async (
  payload: IOfficeMissingInfoProductivityPatch,
  officeId?: string | null,
): Promise<void> => {
  const headers = await scopedHeaders(officeId);
  await tempMeeApi.patch('/users/office-productivity', payload, { headers });
};
